import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SectionGroup = ({ children, id }: { children: React.ReactNode; id?: string }) => {
  return <Wrapper id={id}>{children}</Wrapper>;
};
